module.exports = __webpack_public_path__ + "img/information-circle-red.2dd42cfb.svg";